<template>
  <div class="container pt-3">
    <div class="d-flex justify-content-between align-items-baseline mb-3">
      <!-- Cabecera con logo y switch de impuestos -->
      <div class="col">
        <div class="logo-empresa-servicios-container">
          <img v-if="model?.LogoEmpresaServiciosB64 != ''" :src="model?.LogoEmpresaServiciosB64!"
            class="logo-empresa-servicios" />
        </div>
      </div>
      <div class="col d-flex justify-content-end">
        <div class="mt-2 toggle-impuestos">
          <DxSwitch id="toggle-contratar" v-model:value="impuestosActivo" class="toggle-custom" />
          <span class="texto-impuestos">
            {{
              impuestosActivo
                ? `${$t("wizard.step3.impuestos_incluidos")} (${impuesto.Texto})`
                : $t("wizard.step3.impuestos_incluidos")
            }}
          </span>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-9">
        <!-- Sección de Luz -->
        <div v-if="ofertaLuz && mostrarLuz" class="resumen-card mb-3">
          <p class="fw-bold tipo-energia">
            {{ $t("wizard.resumen.luz") }}
          </p>
          <p class="fw-bold nombre-oferta"><i class="fa-sharp fa-light fa-lightbulb text-success"></i> {{ ofertaLuz.Nombre }}</p>
          <div class="row desglose-oferta mb-3">
            <div class="col">
              <p class="fw-bold categoria mb-0">{{ $t("wizard.resumen.potencia") }}</p>
              <ul>
                <li v-if="ofertaLuz.TerminoPotenciaP1 != null">
                  <span>P1: {{ aplicarImpuestos(ofertaLuz?.TerminoPotenciaP1) }} €/kW/día</span>
                </li>
                <li v-if="ofertaLuz.TerminoPotenciaP2 != null">
                  <span>P2: {{ aplicarImpuestos(ofertaLuz?.TerminoPotenciaP2) }} €/kW/día</span>
                </li>
                <li v-if="ofertaLuz.TerminoPotenciaP3 != null">
                  <span>P3: {{ aplicarImpuestos(ofertaLuz?.TerminoPotenciaP3) }} €/kW/día</span>
                </li>
                <li v-if="ofertaLuz.TerminoPotenciaP4 != null">
                  <span>P4: {{ aplicarImpuestos(ofertaLuz?.TerminoPotenciaP4) }} €/kW/día</span>
                </li>
                <li v-if="ofertaLuz.TerminoPotenciaP5 != null">
                  <span>P5: {{ aplicarImpuestos(ofertaLuz?.TerminoPotenciaP5) }} €/kW/día</span>
                </li>
                <li v-if="ofertaLuz.TerminoPotenciaP6 != null">
                  <span>P6: {{ aplicarImpuestos(ofertaLuz?.TerminoPotenciaP6) }} €/kW/día</span>
                </li>
              </ul>
            </div>
            <div class="col">
              <p class="fw-bold categoria mb-0">{{ $t("wizard.resumen.energia") }}</p>
              <ul>
                <li v-if="ofertaLuz.TerminoEnergiaP1 != null">
                  <span>P1: {{ aplicarImpuestos(ofertaLuz?.TerminoEnergiaP1) }} €/kWh</span>
                </li>
                <li v-if="ofertaLuz.TerminoEnergiaP2 != null">
                  <span>P2: {{ aplicarImpuestos(ofertaLuz?.TerminoEnergiaP2) }} €/kWh</span>
                </li>
                <li v-if="ofertaLuz.TerminoEnergiaP3 != null">
                  <span>P3: {{ aplicarImpuestos(ofertaLuz?.TerminoEnergiaP3) }} €/kWh</span>
                </li>
                <li v-if="ofertaLuz.TerminoEnergiaP4 != null">
                  <span>P4: {{ aplicarImpuestos(ofertaLuz?.TerminoEnergiaP4) }} €/kWh</span>
                </li>
                <li v-if="ofertaLuz.TerminoEnergiaP5 != null">
                  <span>P5: {{ aplicarImpuestos(ofertaLuz?.TerminoEnergiaP5) }} €/kWh</span>
                </li>
                <li v-if="ofertaLuz.TerminoEnergiaP6 != null">
                  <span>P6: {{ aplicarImpuestos(ofertaLuz?.TerminoEnergiaP6) }} €/kWh</span>
                </li>
              </ul>
            </div>
            <div class="col">
              <p class="fw-bold categoria mb-0">{{ $t("wizard.resumen.energia_con_descuento") }}</p>
              <ul>
                <li v-if="ofertaLuz.TerminoEnergiaP1ConDescuentos != null">
                  <span>P1: {{ aplicarImpuestos(ofertaLuz?.TerminoEnergiaP1ConDescuentos) }} €/kWh</span>
                </li>
                <li v-if="ofertaLuz.TerminoEnergiaP2ConDescuentos != null">
                  <span>P2: {{ aplicarImpuestos(ofertaLuz?.TerminoEnergiaP2ConDescuentos) }} €/kWh</span>
                </li>
                <li v-if="ofertaLuz.TerminoEnergiaP3ConDescuentos != null">
                  <span>P3: {{ aplicarImpuestos(ofertaLuz?.TerminoEnergiaP3ConDescuentos) }} €/kWh</span>
                </li>
                <li v-if="ofertaLuz.TerminoEnergiaP4ConDescuentos != null">
                  <span>P4: {{ aplicarImpuestos(ofertaLuz?.TerminoEnergiaP4ConDescuentos) }} €/kWh</span>
                </li>
                <li v-if="ofertaLuz.TerminoEnergiaP5ConDescuentos != null">
                  <span>P5: {{ aplicarImpuestos(ofertaLuz?.TerminoEnergiaP5ConDescuentos) }} €/kWh</span>
                </li>
                <li v-if="ofertaLuz.TerminoEnergiaP6ConDescuentos != null">
                  <span>P6: {{ aplicarImpuestos(ofertaLuz?.TerminoEnergiaP6ConDescuentos) }} €/kWh</span>
                </li>
              </ul>
            </div>
            <div v-if="puedoVerCoste" class="col">
              <p class="fw-bold categoria mb-0">Comisiones</p>
              <ul>
                <li><DesgloseRetribucionEconomica prefijo="Comisión" :importe-total="model?.TramiteLuz?.ComisionEfectiva" 
                  :importe-calculado="model?.TramiteLuz?.Comision" 
                  :importe-reajuste="model?.TramiteLuz?.ReajusteComision" 
                  :motivo-reajuste="model?.TramiteLuz?.MotivoReajusteComision" />
                </li>
                <li><DesgloseRetribucionEconomica prefijo="Retrocomisión" :importe-total="model?.TramiteLuz?.RetrocomisionEfectiva" :importe-calculado="model?.TramiteLuz?.Retrocomision" :importe-reajuste="model?.TramiteLuz?.ReajusteRetrocomision" :motivo-reajuste="model?.TramiteLuz?.MotivoReajusteRetrocomision" /></li>
              </ul>
            </div>
          </div>
          <div class="row desglose-oferta">
            <div v-if="model?.TramiteLuz?.Oferta.TipoCosteGestion != null && model?.TramiteLuz?.Oferta.CosteGestion != null" class="col-md-3">
              <p class="fw-bold categoria mb-0">{{ $t("wizard.resumen.coste_gestion_adicional") }}</p>
              <ul>
                <li>
                  <span class="fw-bold">{{ $n(aplicarImpuestos(model?.TramiteLuz?.Oferta.CosteGestion), "decimal") }} {{ $t(`shared.enums.tipo_coste_gestion.${ofertaLuz?.TipoCosteGestion}`) }}</span>
                </li>
              </ul>
            </div>
            <div class="col">
              <p class="fw-bold categoria mb-0">{{ $t("wizard.resumen.descuentos") }}</p>
              <ul>
                <li v-for="descuento in model?.TramiteLuz?.Descuentos">
                  <span class="fw-bold">{{ descuento.Nombre }} ({{ descuento.Cuantia }}%)</span>
                </li>
              </ul>
            </div>
          </div>
          <OperacionesProductosContratadosTablaServicios
            :servicios="model?.TramiteLuz?.Servicios ?? []"
            :impuestos-activo="impuestosActivo"
            :impuesto="impuesto"
            :id-operacion="model!.Id"
            :tipo-suministro="TipoSuministroTramiteEnergiaEnum.Luz"
            :fecha-activacion-tramite="model!.TramiteLuzFechaActivacion"
            :puede-ver-coste="puedoVerCoste"
          />
        </div>

        <!-- Sección de Gas -->
        <div v-if="ofertaGas && mostrarGas" class="resumen-card">
          <p class="fw-bold tipo-energia">
            {{ $t("wizard.resumen.gas") }}
          </p>
          <p class="fw-bold nombre-oferta"><i class="fa-sharp fa-light fa-fire-flame-simple text-success"></i> {{ ofertaGas.Nombre }}</p>
          <div class="row desglose-oferta mb-3">
            <div class="col">
              <p class="fw-bold categoria mb-0">{{ $t("wizard.resumen.fijo") }}</p>
              <ul>
                <li v-if="ofertaGas.TerminoFijo != null">
                  <span>{{ aplicarImpuestos(ofertaGas?.TerminoFijo) }} €/mes</span>
                </li>
              </ul>
            </div>
            <div class="col">
              <p class="fw-bold categoria mb-0">{{ $t("wizard.resumen.variable") }}</p>
              <ul>
                <li v-if="ofertaGas.TerminoVariable != null">
                  <span>{{ aplicarImpuestos(ofertaGas?.TerminoVariable) }} €/kWh</span>
                </li>
              </ul>
            </div>
            <div class="col">
              <p class="fw-bold categoria mb-0">{{ $t("wizard.resumen.variable_con_descuento") }}</p>
              <ul>
                <li v-if="ofertaGas.TerminoVariableConDescuentos != null">
                  <span>{{ aplicarImpuestos(ofertaGas?.TerminoVariableConDescuentos) }} €/kWh</span>
                </li>
              </ul>
            </div>
            <div v-if="puedoVerCoste" class="col">
              <p class="fw-bold categoria mb-0">Comisiones</p>
              <ul>
                <li><DesgloseRetribucionEconomica prefijo="Comisión" :importe-total="model?.TramiteGas?.ComisionEfectiva" :importe-calculado="model?.TramiteGas?.Comision" :importe-reajuste="model?.TramiteGas?.ReajusteComision" :motivo-reajuste="model?.TramiteGas?.MotivoReajusteComision" /></li>
                <li><DesgloseRetribucionEconomica prefijo="Retrocomisión" :importe-total="model?.TramiteGas?.RetrocomisionEfectiva" :importe-calculado="model?.TramiteGas?.Retrocomision" :importe-reajuste="model?.TramiteGas?.ReajusteRetrocomision" :motivo-reajuste="model?.TramiteGas?.MotivoReajusteRetrocomision" /></li>
              </ul>
            </div>
          </div>
          <div class="row desglose-oferta">
            <div v-if="model?.TramiteGas?.Oferta.TipoCosteGestion != null && model?.TramiteGas?.Oferta.CosteGestion != null" class="col-md-3">
              <p class="fw-bold categoria mb-0">{{ $t("wizard.resumen.coste_gestion_adicional") }}</p>
              <ul>
                <li>
                  <span class="fw-bold">{{ $n(aplicarImpuestos(model?.TramiteGas?.Oferta.CosteGestion), "decimal") }} {{ $t(`shared.enums.tipo_coste_gestion.${model?.TramiteGas?.Oferta.TipoCosteGestion}`) }}</span>
                </li>
              </ul>
            </div>
            <div class="col">
              <p class="fw-bold categoria mb-0">{{ $t("wizard.resumen.descuentos") }}</p>
              <ul>
                <li v-for="descuento in model?.TramiteGas?.Descuentos">
                  <span class="fw-bold">{{ descuento.Nombre }} ({{ descuento.Cuantia }}%)</span>
                </li>
              </ul>
            </div>
          </div>
          <OperacionesProductosContratadosTablaServicios
            :servicios="model?.TramiteGas?.Servicios ?? []"
            :impuestos-activo="impuestosActivo"
            :impuesto="impuesto"
            :id-operacion="model!.Id"
            :tipo-suministro="TipoSuministroTramiteEnergiaEnum.Gas"
            :fecha-activacion-tramite="model!.TramiteGasFechaActivacion"
            :puede-ver-coste="puedoVerCoste"
          />
        </div>
      </div>

      <!-- Panel de Totales -->
      <div v-if="puedoVerCoste" class="col-lg-3 mt-lg-0 mt-3 resumen-card-container">
        <div class="resumen-card">
          <p class="fw-bold tipo-energia">Totales</p>
          <div class="row mt-3">
            <div class="col">
              <p class="fw-bold categoria mb-0">Comisiones</p>
              <ul>
                <li class="fw-bold">{{ totalComisiones }} €</li>
              </ul>
            </div>
            <div class="col">
              <p class="fw-bold categoria mb-0">Retrocomisiones</p>
              <ul>
                <li class="fw-bold">{{ totalRetrocomisiones }} €</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { DxSwitch } from "devextreme-vue/switch";
import { computed, ref } from "vue";
import { TipoSuministroTramiteEnergiaEnum, type DetailOperacionEnergiaModel, type DetailOfertaLuz, type DetailOfertaGas } from "@api/api";
import { determinarImpuesto } from "@helpers/impuestos-helper";
import OperacionesProductosContratadosTablaServicios from "./OperacionesEnergiaProductosContratadosTablaServicios.vue";
import { useAuthorization } from "@/.shared/services/auth/authorization";
import { PermissionsApp } from "@/.shared/services/auth/authorization/authorization-service-impl";
import DesgloseRetribucionEconomica from "@/.shared/components/operacion/DesgloseRetribucionEconomica.vue";

const autho = useAuthorization();

const props = defineProps({
  model: Object as () => DetailOperacionEnergiaModel,
  tramite: String as () => TipoSuministroTramiteEnergiaEnum
});

const ofertaLuz = ref<DetailOfertaLuz | null>(props.model!.TramiteLuz?.Oferta ?? null);
const ofertaGas = ref<DetailOfertaGas | null>(props.model!.TramiteGas?.Oferta ?? null);
const impuestosActivo = ref<boolean>(true);
const impuesto = computed(() => determinarImpuesto(props.model?.Suministro.Direccion?.CodigoPostal));

const mostrarLuz = computed((): boolean => {
  return props.tramite === undefined || props.tramite === TipoSuministroTramiteEnergiaEnum.Luz
});
const mostrarGas = computed((): boolean => {
  return props.tramite === undefined || props.tramite === TipoSuministroTramiteEnergiaEnum.Gas
});

const totalComisiones = computed((): number => {
  let total = 0;

  if(ofertaLuz.value && mostrarLuz.value) {
    total += props.model?.TramiteLuz?.ComisionEfectiva ?? 0;
    total += props.model?.TramiteLuz?.Servicios?.reduce((acc, x) => acc + (x.ComisionEfectiva ?? 0), 0) ?? 0;
  }

  if(ofertaGas.value && mostrarGas.value) {
    total += props.model?.TramiteGas?.ComisionEfectiva ?? 0;
    total += props.model?.TramiteGas?.Servicios?.reduce((acc, x) => acc + (x.ComisionEfectiva ?? 0), 0) ?? 0;
  }

  return total;
});

const totalRetrocomisiones = computed((): number => {
  let total = 0;

  if(ofertaLuz.value && mostrarLuz.value) {
    total += props.model?.TramiteLuz?.RetrocomisionEfectiva ?? 0;
    total += props.model?.TramiteLuz?.Servicios?.reduce((acc, x) => acc + (x.RetrocomisionEfectiva ?? 0), 0) ?? 0;
  }

  if(ofertaGas.value && mostrarGas.value) {
    total += props.model?.TramiteGas?.RetrocomisionEfectiva ?? 0;
    total += props.model?.TramiteGas?.Servicios?.reduce((acc, x) => acc + (x.RetrocomisionEfectiva ?? 0), 0) ?? 0;
  }

  return total;
});

const puedoVerCoste = computed(() => {
  return autho.hasPermission(PermissionsApp.EditAllOperacionesEnergia) || autho.hasPermission(PermissionsApp.ViewDatosEconomicosOperaciones);
})

const aplicarImpuestos = (precio: number) => {
  if (impuesto.value)
    return impuestosActivo.value
      ? parseFloat((precio * impuesto.value.Valor).toFixed(6))
      : precio;

  return precio;
};
</script>

<style lang="scss" scoped>


.toggle-impuestos {
  min-width: 270px;
  box-sizing: content-box !important;
}

.texto-impuestos {
  white-space: nowrap;
  margin-left: 10px;
}

.resumen-card {
  border: 1px solid var(--border-default-default);
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.tipo-energia {
  color: var(--text-secondary-default);
  font-size: 1rem;
  margin-bottom: 8px;
}

.categoria {
  color: var(--text-primary-default);
}

.nombre-oferta {
  font-size: .825rem;
  color: var(--text-primary-default);
}

.desglose-oferta {
  font-size: .75rem;
  font-weight: bold;
}

.resumen-card-container {
  font-size: .825rem;
}

.logo-empresa-servicios-container {
  border: 1px solid var(--border-default-default);
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 250px;
  border-radius: 5px;
}

.logo-empresa-servicios {
  width: 100%;
  height: 80px;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

li {
  padding: 0.25rem 0;
}
</style>